// extracted by mini-css-extract-plugin
export default {"lang":"lang-JzUN"};